import React from "react";
import Button from "../../../components/Button";
import locateIcon from "../assets/locate.svg";
import zoomInIcon from "../assets/zoomIn.svg";
import zoomOutIcon from "../assets/zoomOut.svg";

export function NavigationControls({ onZoomIn, onZoomOut, onLocateUser }) {
  return (
    <div className="navigation-controls">
      <div className="navigation-controls__zoom-group">
        <Button title="zoom-in" theme="box" onClick={onZoomIn}>
          <img src={zoomInIcon} />
        </Button>
        <Button title="zoom-out" theme="box" onClick={onZoomOut}>
          <img src={zoomOutIcon} />
        </Button>
      </div>
      {/* 
      // geo position for user
      <Button
        title="location"
        className="navigation-controls__location-button"
        theme="box"
        onClick={onLocateUser}
      >
        <img src={locateIcon} />
      </Button> */}
    </div>
  );
}
